<script lang="ts" setup>
import MainSnackbarQueue from "@/application/components/MainSnackbarQueue.vue";
import MainConfirmation from "@/application/components/MainConfirmation.vue";
import MainDialog from "@/application/components/MainDialog.vue";
import MainPanel from "@/application/components/MainPanel.vue";
</script>

<template>
  <VApp>
    <RouterView />

    <MainSnackbarQueue />
    <MainConfirmation />
    <MainDialog />
    <MainPanel />
  </VApp>
</template>
